export default __webpack_public_path__ + "media/resources2.1014f7cd.png";